
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/point-of-sale/[slug]",
      function () {
        return require("private-next-pages/point-of-sale/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/point-of-sale/[slug]"])
      });
    }
  